
export class StatusNotificacaoSms {

    codStatusNotificacaoSms: string = '';

    dscStatusNotificacaoSms: string = '';

    constructor() {
    }
}
